module.exports = __webpack_public_path__ + "static/media/Sergey_Lysokobylka.021c6e75.jpg";